import cn from 'classnames';
import { TPlainButtonClick } from 'types/form.types';

import styles from './plainbutton.module.scss';

type TPlainButtonProps = {
  onClickHandler: TPlainButtonClick;
  classes?: string;
  children: string;
};

const PlainButton = ({ children, classes, onClickHandler }: TPlainButtonProps) => (
  <button onClick={onClickHandler} type="button" className={cn(classes, styles.button, 'plainButton text-link font-weight-medium')}>
    {children}
  </button>
);

export default PlainButton;
